// extracted by mini-css-extract-plugin
export default {"notesContainer":"booking_notes_list-module___notesContainer___de8c9645"};